var _defs, _mask, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCollapseArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_collapse_arrow_svg__a",
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_collapse_arrow_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_collapse_arrow_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_collapse_arrow_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.686 25.542l-1.315-1.506 11.63-10.151 11.628 10.15-1.316 1.507L16 16.539z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.686 17.542l-1.315-1.506 11.63-10.151 11.628 10.15-1.316 1.507L16 8.539z"
  })))));
}

export default SvgIconCollapseArrow;